import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getAcitveWOByCont = async ({ params }) => {
  try {
    const response = await commonDefaultAPI.get(`wo-list`, { params });
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getAcitveWOByCont;
